import React, { lazy, Component } from 'react';
export function HeroSection() {
  const handleWhatsApp = () => {
    // Track Lead event
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
    const message = encodeURIComponent('Hola, AGENDAR ASESORÍA - 35% OFF');
    window.open(`https://wa.me/573182434499?text=${message}`, '_blank');
  };
  return <section className="relative min-h-screen bg-[#1A1A1A] flex items-center justify-center overflow-hidden" style={{
    contentVisibility: 'auto'
  }} data-id="element-75">
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/pX8Ywa5YeLCvkK94sLknAT/FONDO_GERFAJ_001.png)'
    }} data-id="element-76" />

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 py-12 md:py-32 text-center" data-id="element-77">
        <h1 className="text-[32px] md:text-[52px] font-extrabold text-white mb-4 md:mb-6" style={{
        lineHeight: '1.15',
        letterSpacing: '-0.02em',
        textShadow: '0 4px 12px rgba(0, 0, 0, 0.8), 0 2px 4px rgba(0, 0, 0, 0.6)'
      }} data-id="element-78">
          Tu obra terminada a tiempo y con cuentas claras.
        </h1>
        <p className="text-[15px] md:text-[17px] text-white/80 font-normal mb-6 md:mb-8 max-w-3xl mx-auto" style={{
        lineHeight: '1.6',
        textShadow: '0 3px 8px rgba(0, 0, 0, 0.7), 0 1px 3px rgba(0, 0, 0, 0.5)'
      }} data-id="element-79">
          Diseño, ejecución y gestión de obra en el área metropolitana de
          Bucaramanga.
        </p>

        <div className="mb-6 md:mb-8 max-w-3xl mx-auto" data-id="element-80">
          <div className="grid grid-cols-2 gap-2 mb-2" data-id="element-81">
            <div className="border-2 border-[#C9922A] rounded-lg overflow-hidden h-40" data-id="element-82">
              <img src="https://cdn.magicpatterns.com/uploads/n8TQYhpqs8JziMbfdczb6A/gerfaj_-_sonesta_01.jpg" alt="Proyecto Sonesta" className="w-full h-full object-cover" width="400" height="300" loading="eager" fetchpriority="high" decoding="async" data-id="element-83" />
            </div>
            <div className="border-2 border-[#C9922A] rounded-lg overflow-hidden h-40" data-id="element-84">
              <img src="https://cdn.magicpatterns.com/uploads/hAeDFGdCDEokVZsNaV1AAi/gerfaj_auditorio_crudo.jpg" alt="Proyecto Auditorio" className="w-full h-full object-cover" width="400" height="300" loading="lazy" decoding="async" data-id="element-85" />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-2" data-id="element-86">
            <div className="border-2 border-[#C9922A] rounded-lg overflow-hidden h-40" data-id="element-87">
              <img src="https://cdn.magicpatterns.com/uploads/reHfES36drLi5CNrcmGny9/gerfaj_campo_hermoso_LANDING.png" alt="Proyecto Campo Hermoso" className="w-full h-full object-cover" width="300" height="300" loading="lazy" decoding="async" data-id="element-88" />
            </div>
            <div className="border-2 border-[#C9922A] rounded-lg overflow-hidden h-40" data-id="element-89">
              <img src="https://cdn.magicpatterns.com/uploads/f1JqnBrner7RsCriRfDhFe/gerfaj_enfermeria.png" alt="Proyecto Enfermería" className="w-full h-full object-cover" width="300" height="300" loading="lazy" decoding="async" data-id="element-90" />
            </div>
            <div className="border-2 border-[#C9922A] rounded-lg overflow-hidden h-40" data-id="element-91">
              <img src="https://cdn.magicpatterns.com/uploads/vZocXYtwuALLEiexNJk2sM/GERFAJ_RUITOQUE_LANDING.png" alt="Proyecto Ruitoque" className="w-full h-full object-cover" width="300" height="300" loading="lazy" decoding="async" data-id="element-92" />
            </div>
          </div>
        </div>

        <p className="text-[15px] md:text-[17px] font-normal mb-8 md:mb-12 max-w-2xl mx-auto text-[#F4F4F4]" style={{
        lineHeight: '1.6',
        textShadow: '0 3px 8px rgba(0, 0, 0, 0.7), 0 1px 3px rgba(0, 0, 0, 0.5)'
      }} data-id="element-93">
          Nos encargamos de todo para que tú solo disfrutes el resultado.
        </p>
        <button onClick={handleWhatsApp} className="w-full md:w-auto bg-[#E8621A] text-white px-8 md:px-12 py-4 md:py-5 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-all shadow-2xl shadow-[#E8621A]/30 hover:scale-105 min-h-[52px]" style={{
        lineHeight: '1',
        letterSpacing: '0.08em'
      }} data-id="element-94">
          AGENDAR ASESORÍA - 35% OFF
        </button>
      </div>
    </section>;
}